import { call, put, takeLatest } from "redux-saga/effects";
import baseApi from "@Apis/Media/api";
import {
  uploadImageErrorAction,
  uploadImageSuccessAction,
} from "@Actions/Media/action";
import { notificationOpenAction } from "@Actions/Notification/action";
import actionTypes from "@Actions/Media/action-types";
import { NOTIFICATION_TYPE } from "@Constants/common";
import { getMediaUrl } from "@Utils/getUrlImages";

export function* uploadImage({ formData ,callbackSuccess, callbackError}: any): any {
  // console.log(formData);
  try {
    const result = yield call(baseApi.uploadImage, formData);
    const fileInfo = Array.isArray(result?.fileInfo) ? result.fileInfo[0] : result?.fileInfo;
    const imageUrl = getMediaUrl(fileInfo?.url || result?.url || fileInfo?.id || result?.result?.id || (Array.isArray(result?.result) ? result.result[0] : result?.result));
    if (fileInfo?.url) fileInfo.url = imageUrl;
    if (Array.isArray(result?.fileInfo) && result.fileInfo[0]) result.fileInfo[0].url = imageUrl;
    if (result?.url) result.url = imageUrl;
    yield callbackSuccess(imageUrl)
    yield put(uploadImageSuccessAction(result));
  } catch (err : any) {
    console.log(err);
    yield put(uploadImageErrorAction(err ));
    yield callbackError()
    yield put(
      notificationOpenAction({
        isNotification: true,
        typeNotification: NOTIFICATION_TYPE.ERROR as "success",
        message: "Lỗi",
        description: err?.response?.data?.message || "Lỗi chưa xác định",
      })
    );
  }
}

export default function* mediaSaga() {
  yield takeLatest(actionTypes?.UPLOAD_IMAGE_START, uploadImage);
}
